import React from 'react'
import styled from 'styled-components';
import image01 from '../../assets/img/inicio_header.png'
import image02 from '../../assets/img/servicios_header.png'
import image03 from '../../assets/img/encomiendas_header.png'
import image04 from '../../assets/img/destinos_header.png'
import image05 from '../../assets/img/contactanos_header.png'

const ContainerHeader = styled.div<{ image: string }>`
    background-image: url(${props => props.image});
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    min-height: 250px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    transition: 1s;

    :after{
        content: '';
        background: #00000040;
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0;
        left: 0;
    }
`


const BodyHeader = styled.div`
    width: 100%;
    height: 100%;
    z-index: 5;
`

interface IItemImage {
  id: number;
  image: string;
}
interface IOwnProps{
    images: IItemImage[];
    children: any;
}

export const listImage = [
  {
    id: 1,
    image: image01
  },
  {
    id: 2,
    image: image02
  },
  {
    id: 3,
    image: image03
  },
  {
    id: 4,
    image: image04
  },
  {
    id: 5,
    image: image05
  },
]

const Header: React.FunctionComponent<IOwnProps> = ({ images, children }) => {
  const [image, setImage] = React.useState(images[0].image  || '')
  let countSize = images.length || 0
  React.useEffect(() => {
    setInterval(() => {
      if(countSize===listImage.length){
        // eslint-disable-next-line react-hooks/exhaustive-deps
        countSize = 0
        setImage(listImage[countSize].image)
      }else{
        setImage(listImage[countSize].image)
        countSize++;
      }
    },5000)
  }, [])

  return (
    <ContainerHeader image={image}>
      <BodyHeader>
        {children}
      </BodyHeader>
    </ContainerHeader>
  )
}

export default Header